import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import PromoCodeList from '../../../../components/SiteAdmin/PromoCode/PromoCodeList';
import Loader from '../../../../components/Common/Loader/Loader';

import getAllPromoCodeQuery from './getAllPromoCode.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

import messages from '../../../../locale/messages';


class PromoCode extends React.Component {

  static defaultProps = { promoCodes: { loading: true } };

  render() {
    const { promoCodes, promoCodes: { loading }, intl: { formatMessage } } = this.props;
    return (
      <Loader type={"page"} show={loading}>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.managePromoCode)}</h1>
        {!loading && <PromoCodeList promoCodes={promoCodes} />}
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withQuery(getAllPromoCodeQuery, {
    name: 'promoCodes',
    options: {
      ssr: false,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1
      }
    }
  }))(PromoCode);